class StockDetails {
    constructor(code, shares, boughtValue) {
        this.code = code;
        this.shares = shares;
        this.boughtValue = boughtValue;
    }

    getCurrentValue() {
      const url = `https://phisix-api3.appspot.com/stocks/${this.code}.json`;
  
      return fetch(url)
          .then(response => response.json())
          .then(data => {
              if (data.stock && data.stock.length > 0) {
                  return data.stock[0].price.amount;
              } else {
                  throw new Error("Stock not found.");
              }
          })
          .catch(error => {
              console.error("Error fetching stock data:", error);
              return "Error fetching stock data";
          });
  }
  
  // Example usage
  
}

export default StockDetails;